export const objectToString = Object.prototype.toString
export const toTypeString = (value : any) => objectToString.call(value)
export const isArray = Array.isArray
export const isMap = (val : any) => toTypeString(val) === '[object Map]'
export const isSet = (val : any) => toTypeString(val) === '[object Set]'
export const isDate = (val : any) => toTypeString(val) === '[object Date]'
export const isRegExp = (val : any) => toTypeString(val) === '[object RegExp]'
export const isFunction = (val : any) => typeof val === 'function'
export const isString = (val : any) => typeof val === 'string'
export const isSymbol = (val : any) => typeof val === 'symbol'
export const isObject = (val : any) => val !== null && typeof val === 'object'
export const isPromise = (val : any) => {
	return isObject(val) && isFunction(val.then) && isFunction(val.catch)
}
export const isUndefined = (val : any) => val === void 0
export const isBoolean = (val : any) => typeof val === 'boolean'
export const isNumber = (val : any) => typeof val === 'number'
export const isEmpty = (val : any) => (!val && val !== 0) || (isArray(val) && val.length === 0) || (isObject(val) && !Object.keys(val).length)
export const isNotEmpty = (val : any) => {
	return !isEmpty(val)
}

export const isNotNull = (val : any) => {
	return (isArray(val) && val.length !== 0) || (isObject(val) && Object.keys(val).length !== 0) || val !== null || val !== 'null' || val !== ''
}

export const isElement = (e : any) => {
	if (typeof Element === 'undefined') return false
	return e instanceof Element
}
export const isMobile = (value : any) => {
	const reg = /^1[3456789]\d{9}$/
	if (!reg.test(value)) {
		return false
	}
	return true
}
export const isStringNumber = (val : any) => {
	if (!isString(val)) {
		return false
	}
	return !Number.isNaN(Number(val))
}